import { useQuery } from '@tanstack/react-query';
import { makeFetchRequest } from 'services/api';

export function useEventsQuery() {
  return useQuery({
    queryKey: ['events'],
    retry: false,
    queryFn: () => makeFetchRequest(`Events`),
  });
}
